import { useQuery } from '@apollo/client';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { TsrctNegotiationCaseStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { Multiline } from '~/components/Multiline';

import { NEGOTIATION_CASE_CANCELLED_ALERT_QUERY } from './NegotiationCaseCancelledAlert.gql';

const CANCELLED_STATUSES: TsrctNegotiationCaseStatus[] = [
  TsrctNegotiationCaseStatus.CANCELLED_AFTER_INVITE_EMAIL_SENT,
  TsrctNegotiationCaseStatus.CANCELLED_BEFORE_INVITE_EMAIL_SENT,
];

export const NegotiationCaseCancelledAlert = ({ negotiationCaseId }: { negotiationCaseId: string }) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationCaseDetailStatusWidget' });
  const { t: tCommon } = useTranslation();
  const { data } = useQuery(NEGOTIATION_CASE_CANCELLED_ALERT_QUERY, {
    variables: { id: negotiationCaseId },
    skip: !negotiationCaseId,
  });

  const negotiationCase = data?.tesseract.negotiationCase;
  if (!negotiationCase || !CANCELLED_STATUSES.includes(negotiationCase.status)) {
    return null;
  }

  const { cancellationReason, cancellationReasonText } = negotiationCase;

  const title = cancellationReason
    ? t('cancelled.titleWithReason', {
        reason: tCommon(`CaseCancellationReason.${cancellationReason}`),
      })
    : t('cancelled.title');
  return (
    <Alert severity="info">
      <AlertTitle>{title}</AlertTitle>
      {isNotNil(cancellationReasonText) && cancellationReasonText !== '' && (
        <Typography variant="body2">
          <Multiline>{t('cancelled.comment', { comment: cancellationReasonText })}</Multiline>
        </Typography>
      )}
    </Alert>
  );
};
